<div class="terrain-opacity-label">
  <strong>
    {{ label() }}
  </strong>
</div>
<div class="form-field form-field__slider">
  <tm-slider
    [min]="0"
    [max]="1"
    [value]="terrainOpacity$ | async"
    [step]="0.01"
    [displayWith]="toPercentageString"
    [label]="label()"
    (valueChange)="setTerrainOpacity($event)">
  </tm-slider>
  <div class="terrain-opacity-reset">
    <button mat-icon-button
            (click)="resetTerrainOpacity()"
            color="primary"
            i18n-tmTooltip="@@core.toc.reset-opacity"
            tmTooltip="Reset opacity">
      <mat-icon svgIcon="reset"></mat-icon>
    </button>
  </div>
</div>
